import { cn } from "@/lib";


interface SidebarFooterProps {
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
}

export const SidebarFooter: React.FC<SidebarFooterProps> = ({ className, style, children }) => {
    return (
        <div
            className={`relative bottom-0 px-4 py-4 bg-surface border-t border-border flex flex-wrap items-center gap-2 justify-between w-full ${className || ''}`}
            style={style}
        >
            {children}
        </div>
    );
};


interface SidebarContentWithFooterProps {
    className?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
}


export const SidebarContent: React.FC<SidebarContentWithFooterProps> = ({ className, style, children }) => {
    return (
        <div className={cn("flex flex-col gap-6 grow px-4 md:px-6 lg:px-8 min-h-0", className)} style={style}>
            {children}
        </div>
    );
};
